// extracted by mini-css-extract-plugin
module.exports = {"h2":"global--h2--2-zLp","h3":"global--h3--1kaPT","h4":"global--h4--Dx11q","h1":"global--h1--vlykZ"};